import { userSettingsByKeySelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { LogoLargeIcn, LogoSmallIcn } from 'utils/icons';

const key = 'isCollapsedLeftPanel';

const LeftPanelHeader = () => {
  const isCollapsedLeftPanel = useTypedSelector((state) => userSettingsByKeySelector({ key, ...state }));

  return (
    <div className="h-16 flex items-center justify-center border-b border-blue-70 dark:border-black-60">
      {!isCollapsedLeftPanel ? <LogoLargeIcn className="w-32 text-black-0" /> : <LogoSmallIcn />}
      {!isCollapsedLeftPanel && (
        <div
          className="text-11 flex items-center justify-center px-1 ml-2.5 h-5 rounded-xl text-black-0 bg-orange-50"
        >
          Supplier
        </div>)}
    </div>
  );
};

export default LeftPanelHeader;
